import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/website/trustees";

export const Route = createFileRoute("/admin/_website/trustees")({
  component: Page,
});
